<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="キャンペーン付与のお知らせ"
        ok-title="クーポンの使用方法"
        ok-variant="yokumiru-orange"
        cancel-title="閉じる"
        cancel-variant="yokumiru-gray"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <div
            v-if="userCoupons && userCoupons.length > 0"
            class="modal-body">
            <div class="vc-notice small">キャンペーンにより、下記クーポンが使用可能になりました。</div>
            <div
                v-for="obj in userCoupons"
                class="vc-campaign">
                <div class="card vc-campaign__card mb-2">
                    <div class="card-body">
                        <p class="vc-campaign__name">{{ obj.campaign.name }}</p>
                        <div
                            v-for="user_coupon in obj.user_coupons"
                            class="vc-coupon">
                            <div class="card mb-2">
                                <div class="card-body">
                                    <div class="vc-coupon__name small text-muted">{{ user_coupon.name }}</div>
                                    <div class="vc-coupon__discount">
                                        <span>{{ user_coupon.discount.toLocaleString() }}</span><!--
                                        --><span>円引き</span>
                                    </div>
                                    <div class="vc-coupon__expired_at">
                                        <span><b-icon-clock/>&nbsp;{{ expiredDate(user_coupon) }}</span>
                                        <span>{{ expiredTime(user_coupon) }}</span>
                                        <span>まで（{{ user.timezone }}）</span>
                                    </div>
                                    <div class="vc-coupon__restrict">
                                        <div v-if="user_coupon.has_doctor_menu">
                                            <div
                                                v-for="(doctor_menu, index) in user_coupon.doctor_menus"
                                                class="d-inline-block">
                                                <span>{{ `${doctor_menu.title}（${doctor_menu.doctor ? doctor_menu.doctor.full_name : '退会済の医師'}）` }}</span><!--
                                        --><span v-if="user_coupon.doctor_menus.length > index + 1">、</span><!--
                                        --><span v-else>メニュー限定</span>
                                            </div>
                                        </div>
                                        <div v-else-if="user_coupon.has_doctor">
                                            <div
                                                v-for="(doctor, index) in user_coupon.doctors"
                                                class="d-inline-block">
                                                <span>{{ doctor.full_name }}</span><!--
                                             --><span v-if="user_coupon.doctors.length > index + 1">、</span><!--
                                             --><span v-else>&nbsp;医師限定</span>
                                            </div>
                                            <div v-if="user_coupon.doctors.length < 1">退会済の医師限定</div>
                                        </div>
                                        <div v-if="user_coupon.min_consultation_price">
                                            <span>{{ user_coupon.min_consultation_price.toLocaleString() }}円以上の{{ $locale.consultation_host }}限定</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="small text-muted mb-0">※&nbsp;クーポンは使用期限を過ぎると無効になりますので、ご注意ください。</p>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'UserCouponsNotificationModal',

        props: {
            user: {
                type: Object,
                required: true,
            },
            userCoupons: {
                type: Array,
                required: true,
            },
            isFirstSetup: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                modalShow: false,
                helper: YokumiruHelper,
            }
        },

        created: function () {
            bus.$on('open-modal-user-coupons-notification', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-user-coupons-notification')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * クーポンの使用方法ボタン押下時
             */
            handleOk: function (e) {
                e.preventDefault()
                bus.$emit('open-modal-how-to-use-coupon')
            },

            /**
             * クーポン使用期限の無期限判定
             *
             * @param {object} user_coupon
             * @return {boolean}
             */
            isExpiredNothing: function (user_coupon) {
                return user_coupon.expired_at === '2100-01-01 00:00:00'
            },

            /**
             * クーポン使用期限表記（日付）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDate: function (user_coupon) {
                return this.helper.dateForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（時刻）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredTime: function (user_coupon) {
                return this.helper.timeForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（曜日）
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDay: function (user_coupon) {
                return this.helper.dayForHuman(user_coupon.expired_at, this.user.timezone)
            },

            /**
             * クーポン使用期限表記（曜日）のCSS
             *
             * @param {object} user_coupon
             * @return {string}
             */
            expiredDayCSS: function (user_coupon) {
                let userTime, day
                userTime = this.helper.userTime(user_coupon.expired_at, this.user.timezone)
                day = userTime.day()

                if (day === 0) return 'text-danger small font-weight-bold'
                if (day === 6) return 'text-yokumiru-blue small font-weight-bold'

                return ''
            },
        },
    }
</script>

<style scoped lang="scss">
    .vc-notice {
        padding: 14px 15px;
        margin-bottom: 15px;
        background: #f5f5f5;
    }

    .vc-campaign {
        .vc-campaign__card {
            background: #f8f8f8;
            border: 1px solid #dee2e6;
            border-radius: 0;
        }

        .vc-campaign__name {
            margin-bottom: 7px;
            font-weight: bold;
            font-size: 1rem;
        }
    }

    .vc-coupon {
        .vc-coupon__name {
            font-size: .75rem;
            line-height: 1.3;
        }

        .vc-coupon__discount {
            margin-left: 1px;
            color: #5f6366;
            font-size: 1.1rem;
            font-weight: bold;
            line-height: 1.3;

            span {
                &:nth-child(2) {
                    font-size: .75rem;
                }
            }
        }

        .vc-coupon__expired_at {
            margin-top: 5px;
            color: #5f6366;
            font-size: .7rem;

            span {
                &:nth-child(1),
                &:nth-child(2) {
                    font-weight: bold;
                }
            }
        }

        .vc-coupon__restrict {
            margin-left: 15px;
            color: #5f6366;
            font-size: .7rem;
        }
    }
</style>
